module.exports = __webpack_public_path__ + "static/media/Flag_of_Kurdistan2.d22f9968.svg";